import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dc30d16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "features" }
const _hoisted_2 = { class: "f-location" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Poznań, Poland", -1))
const _hoisted_4 = { class: "f-yo" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "f-lang-pl" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/polish.svg",
    alt: "Polish language - native"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "Native")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "f-lang-en" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/english.svg",
    alt: "English language - B1 + technical"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "B1")
], -1))
const _hoisted_7 = { class: "contact s-static" }
const _hoisted_8 = { class: "l-static i-features" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/in/bartosz-wojcieszek-9b17b5248/",
    target: "_blank"
  }, "Linked in")
], -1))
const _hoisted_10 = { class: "c-mail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:bartosz.wojcieszek@gmail.com",
    target: "_blank"
  }, "Mail me")
], -1))
const _hoisted_12 = { class: "why-me s-static" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Why me?", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " For many years i have to getting experience in work with developers. I know that key point for best projects is: comfortable and fun atmosphere in dev squads, modern tools and space for self-development. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "My diamonds:", -1))
const _hoisted_16 = { class: "l-static i-features" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("+10y commercial"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" experience")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("quality-first"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" doctrine")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("teamwork"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" enhancer")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("fast learning"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" and adaptation")
], -1))
const _hoisted_21 = { class: "skills s-static" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "My skills", -1))
const _hoisted_23 = { class: "l-static i-features" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Vue 3 "),
  /*#__PURE__*/_createElementVNode("small", null, "(composition API)")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Node.js "),
  /*#__PURE__*/_createElementVNode("small", null, "(Express, NestJS)")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TypeScript", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Project Management", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Google Cloud", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "GitLab CI/CD", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Docker", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nginx", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mercure", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("PHP8 "),
  /*#__PURE__*/_createElementVNode("small", null, "(Symfony)")
], -1))
const _hoisted_34 = { class: "best-stacks s-static" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Best stacks", -1))
const _hoisted_36 = { class: "l-static i-features" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Vue3 + Node.js + Google Cloud "),
  /*#__PURE__*/_createElementVNode("small", null, "(TypeScript, Vite accelerator, Vuex, tailwind, NestJS)")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Vue3 + Symfony + Mercure "),
  /*#__PURE__*/_createElementVNode("small", null, "(TypeScript, Vite, Vuex, AMQP)")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("HTML + VanilaJS + Node.js "),
  /*#__PURE__*/_createElementVNode("small", null, "(TypeScript, webpack, ExpressJS, SASS)")
], -1))
const _hoisted_40 = { class: "nearest-targets s-static" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nearest targets", -1))
const _hoisted_42 = { class: "l-static i-features" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Datadog "),
  /*#__PURE__*/_createElementVNode("small", null, "Application and server performance monitoring")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("AWS "),
  /*#__PURE__*/_createElementVNode("small", null, "Discover the beast!")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("XRAY "),
  /*#__PURE__*/_createElementVNode("small", null, "Automated testing")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Kubernetes "),
  /*#__PURE__*/_createElementVNode("small", null, "Production-identical environments for development")
], -1))
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<section class=\"experience s-static\" data-v-3dc30d16><h2 data-v-3dc30d16>Experience</h2><ul data-v-3dc30d16><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2023 - *</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>senior frontend in DropHUB</strong><br data-v-3dc30d16><small data-v-3dc30d16>e-commerce Vue3 app based on webcomponents</small></li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2021 - 2022</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>senior frontend in Movity</strong><br data-v-3dc30d16><small data-v-3dc30d16>(huge Vue financial app with handling tons of data)</small></li><li data-v-3dc30d16><strong data-v-3dc30d16>fullstack dev - Node.js and Vue based CMS platform</strong><br data-v-3dc30d16><small data-v-3dc30d16>(powered by Google Cloud)</small></li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2020 - *</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>principal frontend and tech support in Newaxis</strong><br data-v-3dc30d16><small data-v-3dc30d16>(support for developers in they daily works and improving they skills)</small></li><li data-v-3dc30d16><strong data-v-3dc30d16>tech lead and devops in benchmark.pl</strong><br data-v-3dc30d16><small data-v-3dc30d16>(leading in planning and creation of new content platform; maintainment and support)</small></li><li data-v-3dc30d16> plan, develop and release financial app for massive factoring in Vue-Node.js stack </li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2017 - *</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>recruiter in Newaxis</strong></li><li data-v-3dc30d16><strong data-v-3dc30d16>recruiter in Komputronik</strong></li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2017 - 2019</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>senior frontend in Newaxis</strong><br data-v-3dc30d16><small data-v-3dc30d16>(build and maintainment environment used to fast develop a huge number of static landing pages)</small></li><li data-v-3dc30d16><strong data-v-3dc30d16>regular frontend in Komputronik</strong><br data-v-3dc30d16><small data-v-3dc30d16>(plan and develop new frontend platform for e-commenrce in big squad)</small></li><li data-v-3dc30d16><strong data-v-3dc30d16>tech lead in benchmark.pl</strong><br data-v-3dc30d16><small data-v-3dc30d16>(management, devops, maintainment and develop features for one of the biggest tech-news portal)</small></li><li data-v-3dc30d16> first play with Node.js </li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2013 - 2016</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>fullstack developer in Newaxis</strong><br data-v-3dc30d16><small data-v-3dc30d16>(various projects with much more varius stacks for external agency)</small></li><li data-v-3dc30d16><strong data-v-3dc30d16>first maintainment and development works for benchmark.pl</strong><br data-v-3dc30d16><small data-v-3dc30d16>(then began my adventure with very responsible project)</small></li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2009-2012</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16><strong data-v-3dc30d16>working as freelancer</strong><br data-v-3dc30d16><small data-v-3dc30d16>(usualy in HTML-PHP-MySQL stack)</small></li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2006</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16> modern website for my high school </li><li data-v-3dc30d16> first plays with bash </li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2005</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16>first modern website for social activity association in my city</li></ul></div></li><li class=\"e-item\" data-v-3dc30d16><span class=\"e-ball\" data-v-3dc30d16></span><div class=\"e-content\" data-v-3dc30d16><time data-v-3dc30d16>2004</time><ul class=\"e-details\" data-v-3dc30d16><li data-v-3dc30d16>first plays with programming - interactive forms powered by JavaScript</li></ul></div></li></ul></section>", 1)
const _hoisted_48 = { class: "education s-static" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Education", -1))
const _hoisted_50 = { class: "l-static i-features" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Poznań Universitet of Technology "),
  /*#__PURE__*/_createElementVNode("small", null, "information technology")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Cyprian Kamil Norwid Secondary School in Koszalin "),
  /*#__PURE__*/_createElementVNode("small", null, "with IT profile")
], -1))
const _hoisted_53 = { class: "about-me s-static" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "About me", -1))
const _hoisted_55 = { class: "l-static i-features" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/ipsc.svg",
    alt: "International Practical Shooting Confederation"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "IPSC Shooter")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Skating", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Fishing", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Mountain traveling", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")!
  const _component_icon_component = _resolveComponent("icon-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_component, {
      "top-bg": {
      mobile: '/bartek-bg-mobile.jpg',
      desktop: '/bartek-bg.jpg',
    },
      avatar: "/avatar-bartek.png",
      firstname: "Bartosz",
      lastname: "Wojcieszek",
      back: "/"
    }, null, 8, ["top-bg"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_2, [
          _createVNode(_component_icon_component, {
            size: 36,
            icon: _ctx.IconKey.LOCALIZATION
          }, null, 8, ["icon"]),
          _hoisted_3
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.yearsOld) + " y.o.", 1)
        ]),
        _hoisted_5,
        _hoisted_6
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LINKEDIN,
            fill: "#1151b8"
          }, null, 8, ["icon"]),
          _hoisted_9
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.MAIL,
            fill: "#0066ec"
          }, null, 8, ["icon"]),
          _hoisted_11
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("ul", _hoisted_16, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.DIAMOND,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _hoisted_17
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.DIAMOND,
            fill: "#6aa05c"
          }, null, 8, ["icon"]),
          _hoisted_18
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.DIAMOND,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_19
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.DIAMOND,
            fill: "#225f21"
          }, null, 8, ["icon"]),
          _hoisted_20
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("ul", _hoisted_23, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#569a4c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_24
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#569a4c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.HALF_STAR,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_25
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#569a4c"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#3e863d"
          }, null, 8, ["icon"]),
          _hoisted_26
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.HALF_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_27
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.HALF_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_28
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_29
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.HALF_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_30
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_31
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#5809fb"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#6910f4"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#8428f9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.HALF_STAR,
            fill: "#a610c9"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#c20caf"
          }, null, 8, ["icon"]),
          _hoisted_32
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#10204b"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#0b3066"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#044b8f"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FULL_STAR,
            fill: "#0059a6"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EMPTY_STAR,
            fill: "#0059a6"
          }, null, 8, ["icon"]),
          _hoisted_33
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("ul", _hoisted_36, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#699f5c"
          }, null, 8, ["icon"]),
          _hoisted_37
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#999"
          }, null, 8, ["icon"]),
          _hoisted_38
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#6bbf47"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#75ad64"
          }, null, 8, ["icon"]),
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.BOLT,
            fill: "#999"
          }, null, 8, ["icon"]),
          _hoisted_39
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("ul", _hoisted_42, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_43
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_44
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_45
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LIGHTBULB,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_46
        ])
      ])
    ]),
    _hoisted_47,
    _createElementVNode("section", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("ul", _hoisted_50, [
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EDUCATION,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_51
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.EDUCATION,
            fill: "#fea620"
          }, null, 8, ["icon"]),
          _hoisted_52
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_53, [
      _hoisted_54,
      _createElementVNode("ul", _hoisted_55, [
        _hoisted_56,
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.SKATING
          }, null, 8, ["icon"]),
          _hoisted_57
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.FISHING
          }, null, 8, ["icon"]),
          _hoisted_58
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_icon_component, {
            icon: _ctx.IconKey.LANDSCAPE
          }, null, 8, ["icon"]),
          _hoisted_59
        ])
      ])
    ])
  ], 64))
}